export const companyInfo = {
  name: "South Palmyra Inc.",
  phone: "(825) 333-1017",
  phoneSecondary: "(587) 930-4145",
  email: "southpalmyra.inc@gmail.com",
  serviceArea: "Edmonton & Area",
  logo: "/images/4996888999871843250.jpg"
};

export const services = [
  {
    id: 1,
    title: "Window & Door Expansions",
    description: "Enlarging existing openings or cutting new ones in your foundation for natural light and safety.",
    icon: "Home",
    features: [
      "Foundation window openings - creating new egress windows for legal living spaces",
      "Existing opening expansion - enlarging basement windows to meet Alberta Building Code",
      "Door opening creation - new entry points for basement access",
      "Code compliant installations - ensuring all openings meet safety requirements",
      "Specialized diamond cutting equipment for minimal dust and perfect edges"
    ],
    image: "/images/photo_5116493174661647892_y.jpg"
  },
  {
    id: 2,
    title: "Full Window Installation",
    description: "Turn-key solutions including excavation, window well setup, drainage systems, and energy-efficient window fitting.",
    icon: "Hammer",
    features: [
      "Complete excavation services - professional digging around foundation",
      "Window well installation - durable protective enclosures for basement windows",
      "Drainage system setup - preventing water buildup and basement flooding",
      "Energy-efficient window fitting - proper sealing and insulation",
      "Waterproofing and finishing - moisture protection for long-lasting results",
      "Full turn-key service - from start to finish with zero stress"
    ],
    image: "/images/photo_5116493174661647893_y.jpg"
  },
  {
    id: 3,
    title: "Floor & Slab Cutting + Demolition",
    description: "Creating openings for new staircases and plumbing, plus full concrete demolition with debris haul-away.",
    icon: "Trash2",
    features: [
      "Floor cutting for staircases - precise openings for new basement access",
      "Plumbing openings - cutting concrete for new plumbing installations",
      "Wall and partition removal - demolishing unwanted concrete structures",
      "Old staircase removal - dismantling and disposal of concrete stairs",
      "Full debris haul-away - complete cleanup and waste removal",
      "Clean and precise work - minimal disruption to your property"
    ],
    image: "/images/4996888999871843252.jpg"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "/images/photo_5116493174661647893_y.jpg",
    title: "Egress Window with Window Well",
    category: "windows"
  },
  {
    id: 2,
    url: "/images/photo_5116493174661647891_y.jpg",
    title: "Window Well with Drainage",
    category: "windows"
  },
  {
    id: 3,
    url: "/images/4996888999871843261.jpg",
    title: "Window Well Installation Complete",
    category: "windows"
  },
  {
    id: 4,
    url: "/images/4996888999871843250.jpg",
    title: "Egress Window Brick Wall",
    category: "windows"
  },
  {
    id: 5,
    url: "/images/photo_5116493174661647883_y.jpg",
    title: "Basement Window Interior",
    category: "windows"
  },
  {
    id: 6,
    url: "/images/photo_5116493174661647884_y.jpg",
    title: "New Window Installed Inside",
    category: "windows"
  },
  {
    id: 7,
    url: "/images/photo_5116493174661647887_y.jpg",
    title: "Wide Basement Window",
    category: "windows"
  },
  {
    id: 8,
    url: "/images/4996888999871843253.jpg",
    title: "Finished Window Beige Room",
    category: "windows"
  },
  {
    id: 9,
    url: "/images/4996888999871843254.jpg",
    title: "Finished Window Green Room",
    category: "windows"
  },
  {
    id: 10,
    url: "/images/4996888999871843255.jpg",
    title: "Basement Window Night View",
    category: "windows"
  },
  {
    id: 11,
    url: "/images/4996888999871843256.jpg",
    title: "Large Egress Window Inside",
    category: "windows"
  },
  {
    id: 12,
    url: "/images/4996888999871843259.jpg",
    title: "New Window with Foam Seal",
    category: "windows"
  },
  {
    id: 13,
    url: "/images/photo_5116493174661647885_y.jpg",
    title: "Concrete Wall Window",
    category: "windows"
  },
  {
    id: 14,
    url: "/images/photo_5116493174661647892_y.jpg",
    title: "Foundation Work in Progress",
    category: "concrete-cutting"
  },
  {
    id: 15,
    url: "/images/photo_5116493174661647889_y.jpg",
    title: "Large Opening Excavation",
    category: "concrete-cutting"
  },
  {
    id: 16,
    url: "/images/photo_5116493174661647888_y.jpg",
    title: "Foundation Opening Ready",
    category: "concrete-cutting"
  },
  {
    id: 17,
    url: "/images/photo_5116493174661647890_y.jpg",
    title: "Existing Basement Window",
    category: "concrete-cutting"
  },
  {
    id: 18,
    url: "/images/4996888999871843249.jpg",
    title: "Concrete Cutting with Tools",
    category: "concrete-cutting"
  },
  {
    id: 19,
    url: "/images/4996888999871843251.jpg",
    title: "Foundation Opening Exterior",
    category: "concrete-cutting"
  },
  {
    id: 20,
    url: "/images/4996888999871843257.jpg",
    title: "Foundation Excavation",
    category: "concrete-cutting"
  },
  {
    id: 21,
    url: "/images/4996888999871843258.jpg",
    title: "Opening Ready for Window",
    category: "concrete-cutting"
  },
  {
    id: 22,
    url: "/images/4996888999871843260.jpg",
    title: "Foundation Preparation",
    category: "concrete-cutting"
  },
  {
    id: 23,
    url: "/images/4996888999871843252.jpg",
    title: "Concrete Slab Removed",
    category: "concrete-cutting"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Thompson",
    location: "Edmonton, AB",
    rating: 5,
    text: "South Palmyra Inc. did an excellent job cutting openings for our new basement windows. Professional, efficient, and clean work. Highly recommended!",
    project: "Basement Window Installation"
  },
  {
    id: 2,
    name: "Sarah Martinez",
    location: "St. Albert, AB",
    rating: 5,
    text: "Needed foundation work done quickly. The team was professional, completed the job on time, and the site was left spotless. Great experience!",
    project: "Foundation Cutting"
  },
  {
    id: 3,
    name: "Mike Davidson",
    location: "Sherwood Park, AB",
    rating: 5,
    text: "Impressive concrete cutting work. They handled our complex project with expertise and attention to detail. Will definitely use them again.",
    project: "Concrete Demolition"
  }
];

export const submitQuoteRequest = (formData) => {
  console.warn('Using deprecated mock submitQuoteRequest. Please use API service instead.');
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Quote request received! We'll contact you within 24 hours." });
    }, 1000);
  });
};
